import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  Typography,
  Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';

const { Text } = Typography;
const { TextArea } = Input;

function InterestEdit({
  isOpen,
  toggle,
  initialValues,
  onSubmit,
  status,
  type,
  onImageUpload,
  beforeImageUpload,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      imageLink: initialValues.imageLink,
    });
  }, [initialValues]);

  return (
    <Modal
      title={type === 'ADD' ? 'Add Info' : 'Edit info'}
      visible={isOpen}
      footer={null}
      onCancel={toggle}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
          form={form}
        >
          <Form.Item
            label="Title(Max 100 Chars)"
            name="title"
            rules={[
              { required: true, message: 'Please input title!' },
              {
                max: 100,
                message: 'Title cannot be more than 100 characters!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Upload
            beforeUpload={beforeImageUpload}
            customRequest={onImageUpload}
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
          <Form.Item
            label="Image Link"
            name="imageLink"
            rules={[{ required: true, message: 'Please input link!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: 'Please input description!' },
              {
                max: 250,
                message: 'Description cannot be more than 250 characters!',
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">Successfully Updated!</Text>
          ) : null}
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                {type}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default InterestEdit;
